import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { Iroles } from 'src/types/Utils';
import { formatString } from 'src/util/STR';
//import {} from '../types/Utils';
import { baseQueryUtils } from './baseQueryUtils';

export const userGroupManagement = createApi({
  baseQuery: baseQueryUtils,
  reducerPath: 'UserGroupManagement',
  endpoints: builder => ({
    getClientRoles: builder.query<Iroles, { group_name: string; client_name: string }>({
      query: ({ group_name, client_name }) => ({
        url: formatString(
          endPoints.UserGroupManagement.selectClientRoles,
          { key: urlKeys.group_name, value: group_name },
          { key: urlKeys.client_name, value: client_name }
        ),
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const { useGetClientRolesQuery } = userGroupManagement;
